import { render, staticRenderFns } from "./OptionNode.vue?vue&type=template&id=6b05fa3a&scoped=true&"
import script from "./OptionNode.vue?vue&type=script&lang=js&"
export * from "./OptionNode.vue?vue&type=script&lang=js&"
import style0 from "./OptionNode.vue?vue&type=style&index=0&id=6b05fa3a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05fa3a",
  null
  
)

export default component.exports